export class CCreateEntreprise {

  name: string | undefined;
  linkedin_link: string | undefined;
  website_link: string | undefined;
  type: number | undefined; // Mettre à jour le type en number
  email: string | undefined;
  password: string | undefined;
  idCompany: string | null;

  constructor(data?: CCreateEntreprise) {

    this.name = data && data.name || "";
    this.linkedin_link = data && data.linkedin_link || "";
    this.website_link = data && data.website_link || "";
    this.type = data && typeof data.type === 'number' ? data.type : undefined; // Mettre à jour la valeur en tant que nombre
    this.email = data && data.email || "";
    this.password = data && data.password || "";
    this.idCompany = data && data.idCompany || null;
  }
}

  export interface IEntreprise{
    name: string;
    phone_number: string;
    linkedin_link: string;
    website_link: string | null;
    type: number | null; // Mettre à jour le type en number
    email: string | null;
    password: string | null;
    idCompany:string|null;
  }
  
  export const type=[
    { id: 2, name: 'ESN' },
    { id: 3, name: 'Client final' },
    { id: 4, name: 'Cabinet de Recrutement'},
  ]
  export const headerColumns=[
    { checked: true, name: 'ID', code: 'ID' },
    { checked: true, name: 'Entreprise', code: 'name' },
    { checked: true, name: 'Type', code: 'type' },
    { checked: true, name: 'Avis', code: 'average_note' },
    { checked: true, name: 'Taille', code: 'size_company' },
    { checked: true, name: 'Pays', code:'country' },
    { checked: true, name: 'Ville', code: 'city' },
    { checked: true, name: 'Email', code: 'ContactEmail' },
    { checked: true, name: 'N°Tel', code: 'ContactPhone' },
    { checked: true, name: 'Dernière connexion', code: 'last_connection' },
  ];